/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventGroup,
    JsonEventGroupFromJSON,
    JsonEventGroupFromJSONTyped,
    JsonEventGroupToJSON,
} from './JsonEventGroup';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventGroup
 */
export interface ApiResultOfJsonEventGroup {
    /**
     * 
     * @type {JsonEventGroup}
     * @memberof ApiResultOfJsonEventGroup
     */
    data?: JsonEventGroup;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventGroup
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventGroup
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventGroup
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventGroup
     */
    result?: ApiResultOfJsonEventGroupResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventGroupResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventGroupFromJSON(json: any): ApiResultOfJsonEventGroup {
    return ApiResultOfJsonEventGroupFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventGroupFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventGroupToJSON(value?: ApiResultOfJsonEventGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventGroupToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

